import React from "react";

interface Props {
  isLoading: boolean;
  month: number;
  year: number;
  monthsOptions: string[];
  yearsOptions: number[];
  handleToday: () => void;
  handleArrowDateChange: (action: "next" | "previous") => void;
  handleDateChange: (newYear: number, newMonth: number) => void;
}

export const EventsHeader: React.FC<Props> = ({
  month,
  year,
  isLoading,
  handleToday,
  handleDateChange,
  yearsOptions,
  monthsOptions,
  handleArrowDateChange,
}) => {
  return (
    <div className="events-header">
      <div className="events-navigation">
        <button
          type="button"
          className="events-nav-button"
          onClick={() => handleArrowDateChange("previous")}
        >
          &#8249;
        </button>
        <div className="events-selectors">
          <select
            className="events-select"
            value={month}
            onChange={(e) => handleDateChange(year, Number(e.target.value))}
          >
            {monthsOptions.map((name, index) => (
              <option key={index} value={index}>
                {name}
              </option>
            ))}
          </select>
          <select
            className="events-select"
            value={year}
            onChange={(e) => handleDateChange(Number(e.target.value), month)}
          >
            {yearsOptions.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
        </div>
        <button
          type="button"
          className="events-nav-button"
          onClick={() => handleArrowDateChange("next")}
        >
          &#8250;
        </button>
      </div>
      <div className="events-header-right">
        {isLoading && <span className="events-loading">Loading...</span>}
        <button type="button" className="events-today-button" onClick={handleToday}>
          Today
        </button>
      </div>
    </div>
  );
};
